'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint no-undef: "off" */
/**
 * select specifications modal
 */
define('selectSpecModal',['util', 'vue', 'jquery', 'productInfoImgApi', 'shoppingCartApi', 'addToCartApi', 'busEvent', 'addPreOrderApi', 'getCityQtyApi', 'buyNowApi', 'appStorage', 'GAReport', 'bottomSheet', 'confirmDialog', 'serialize'], function (Util, Vue, $, productInfoImgApi, shoppingCartApi, addToCartApi, busEvent, addPreOrderApi, getCityQtyApi, buyNowApi, appStorage, GAReport, bottomSheet, confirmDialog) {
  return {
    template: '\n      <div class="in-select-spec-container">\n        <bottom-sheet\n          :visible="visible"\n          title=""\n          sheet-class="xp-spec-bottom-sheet"\n          :show-confirm="false"\n          @close="closePanel">\n          <div class="in-container xp-spec-sheet">\n            <div class="xp-spec-product">\n              <div class="xp-spec-product-image">\n                <img :src="modalImage" />\n              </div>\n              <div class="xp-spec-product-price">\n                <div class="xp-spec-current-price in-Montreal" v-html="productInfo.price_label"></div>\n                <del class="xp-spec-origin-price in-Montreal" v-if="productInfo.origin_price_label" v-html="productInfo.origin_price_label"></del>\n              </div>\n            </div>\n\n            <div class="in-attrs-container xp-spec-attrs">\n              <div class="in-choose-attrs" :name="item.code" :parent="index" v-for="(item,index) in productInfo.configattr">\n                <div class="in-label" v-text="item.frontend_label"></div>\n                <ul>\n                  <li v-for="(itemOption,optionIndex) in item.options" :optionId="itemOption.option_id">\n                    <a href="javascript:void(0);" :optionindex="optionIndex" v-text="itemOption.label" @click.prevent="chooseAttr(itemOption, $event)"></a>\n                  </li>\n                </ul>\n              </div>\n              <div class="in-choose-attrs xp-spec-qty-row">\n                <div class="in-label" v-text="i18n.qty"></div>\n                <div class="in-product-qty">\n                  <button\n                    type="button"\n                    class="xp-spec-qty-btn xp-spec-minus"\n                    :class="{\'is-disabled\': isDecreaseDisabled}"\n                    :disabled="isDecreaseDisabled"\n                    @click.prevent="decrease"\n                  ></button>\n                  <p class="" v-text="qty"></p>\n                  <button\n                    type="button"\n                    class="xp-spec-qty-btn xp-spec-plus"\n                    :class="{\'is-disabled\': isIncreaseDisabled}"\n                    :disabled="isIncreaseDisabled"\n                    @click.prevent="increase"\n                  ></button>\n                </div>\n                <p class="error-tips" v-if="noGoodsFlag && !isPickUp" v-text="i18n.noGoods"></p>\n              </div>\n            </div>\n            <div v-if="item.title !== \'base\' && item.show" v-for="item in productInfo.attachment.option" class="in-choose-attrs">\n              <div class="in-label" v-text="item.title"></div>\n              <div class="in-product-package">\n                <section v-for="(option,index) in item.options" v-if="option.status === \'1\'" class="in-package-item" @click.prevent="choosePackage($event, option, item)">\n                  <div class="in-package-pic">\n                    <img :src="option.image" />\n                  </div>\n                  <div class="in-package-info">\n                    <h6 v-text="option.name"></h6>\n                    <p><span v-html="option.price_label"></span><del v-if="option.oldprice !== option.price" v-html="option.oldprice_label"></del></p>\n                  </div>\n                  <div>\n                    <i class="xmall-icon"></i>\n                  </div>\n                </section>\n              </div>\n            </div>\n          </div>\n          <template slot="footer">\n            <div class="in-btn xp-spec-footer">\n              <div class="xp-spec-footer-actions" v-if="action !== \'pickUp\' && action !== \'specs\'">\n                <a\n                  v-if="cartToStock === i18n.outOfStock"\n                  href="javascript:void(0);"\n                  class="in-add-cart xp-spec-add-cart-btn in-disabled"\n                >\n                  <span v-text="cartToStock"></span>\n                </a>\n\n                <template v-else>\n                  <a\n                    v-if="isShowAddToCartBtn && (productBlock === \'\' ||\n                    productBlock === \'group_sale\' ||\n                    productBlock === \'flash_sales\' ||\n                    ((productBlock === \'pre_order\' &&\n                    productInfo.level === \'add_to_cart\') ||\n                    productInfo.can_direct_shopping === \'1\'))"\n                    href="javascript:void(0);"\n                    class="in-add-cart xp-spec-add-cart-btn"\n                    @click.prevent="addToCart"\n                    :class="{\'active\': cartToStock === i18n.addToCart, \'in-disabled\': cartToStock === i18n.outOfStock}"\n                  >\n                    <span>\n                      {{\n                        cartToStock !== i18n.outOfStock ? i18n.addToCart : cartToStock\n                      }}\n                    </span>\n                  </a>\n\n                  <a\n                    v-if="isShowBuyNowBtn"\n                    href="#"\n                    class="in-add-cart active xp-spec-buy-now-btn"\n                    @click.prevent="buyNow"\n                    :class="{\'in-disabled\': cartToStock === i18n.outOfStock}"\n                  >\n                    <span>\n                      {{\n                        cartToStock !== i18n.outOfStock ? i18n.buyNow : cartToStock\n                      }}\n                    </span>\n                  </a>\n                </template>\n\n                <a v-if="productBlock === \'pre_order\' && productInfo.can_direct_shopping === \'0\' && productInfo.level === \'pre\'" href="javascript:void(0);" class="in-add-cart in-pre-order xp-spec-buy-now-btn" @click.prevent="joinPreOrder" :class="{\'active\': preOrderToStock === i18n.joinNow, \'in-disabled\': preOrderToStock === i18n.outOfStock || productInfo.pre_order_is_join}">\n                  <span v-text="preOrderToStock"></span>\n                </a>\n              </div>\n\n              <template v-if="action === \'pickUp\' || action === \'specs\'">\n                <a\n                  class="xp-spec-confirm-btn"\n                  :class="{\n                    \'active\': action === \'specs\' || !isPickupConfirmDisabled,\n                    \'in-disabled\': action === \'pickUp\' && isPickupConfirmDisabled\n                  }"\n                  @click.prevent="closePanel"\n                >\n                  <span v-text="i18n.confirm"></span>\n                </a>\n              </template>\n            </div>\n          </template>\n        </bottom-sheet>\n        <div class="in-info in-modal-box xp-ui">\n          <confirm-dialog\n            name="addToCartSuccessDialog"\n            :title="successDialogTitle"\n            :buttons="successDialogButtons"\n            @action="handleSuccessDialogAction"\n          ></confirm-dialog>\n        </div>\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          addToCart: 'Add to Cart',
          addedToCart: 'added to your cart',
          checkout: 'Checkout',
          outOfStock: 'Out Of Stock',
          selectAttr: 'Please select sufficient properties',
          overQty: ' can be purchased at most',
          qty: 'Quantity',
          joinNow: 'JOIN NOW',
          joined: 'JOINED',
          presellAuthority: 'Only avaliable for customers who participated in advance.',
          noGoods: 'No goods in current area',
          buyNow: 'Buy Now',
          confirm: 'Confirm'
        },
        isUnpurchasable: false,
        productId: window.productId,
        cacheAttr: {},
        chooseProductId: 0, // 选中的产品id
        chooseProductAttr: new Map(), // 选中的product attr
        lastChooseProductId: 0, // 上一次选中的产品id
        qty: 1, // 默认product qty=1
        selectedItemDesc: '',
        isLogin: !!appStorage.get('token'),
        loginUrl: window.commonDataJSON.login_url,
        chooseProductPackage: new Map(),
        action: 'addToCart',
        selectOptions: [],
        visible: false,
        successDialogTitle: '',
        showTimer: null,
        onShowSpecModal: null,
        onHideSpecModal: null
      };
    },

    props: {
      useGlobalSuccessModal: {
        type: Boolean,
        default: false
      },
      productInfo: {
        type: Object,
        required: true
      },
      noGoodsFlag: {
        type: Boolean,
        required: false
      },
      isPickUp: {
        type: Boolean,
        required: false
      },
      isOnlyPickUp: {
        type: Boolean,
        required: false
      }
    },
    components: {
      bottomSheet: bottomSheet,
      confirmDialog: confirmDialog
    },
    computed: {
      productBlock: function productBlock() {
        var block = this.productInfo.block;
        if (Array.isArray(block)) {
          return block[0] || '';
        }
        return block || '';
      },

      /**
       * 根据选中的config product与库存 返回add to cart 和 out of stock
       * @returns {*}
       */
      cartToStock: function cartToStock() {
        if (this.chooseProductId === 0) {
          return this.i18n.addToCart;
        }
        if (this.productInfo.product_type === 'simple' && this.productInfo.status) {
          return this.i18n.addToCart;
        }
        if (this.productInfo.product_type === 'configurable' && this.productInfo.configproduct['key_' + this.chooseProductId].status) {
          return this.i18n.addToCart;
        }
        this.isUnpurchasable = true;
        return this.i18n.outOfStock;
      },
      preOrderToStock: function preOrderToStock() {
        if (this.productInfo.pre_order_is_join) {
          return this.i18n.joined;
        }
        if (this.chooseProductId === 0) {
          return this.i18n.joinNow;
        }
        if (this.productInfo.product_type === 'simple' && this.productInfo.status) {
          return this.i18n.joinNow;
        }
        if (this.productInfo.product_type === 'configurable' && this.productInfo.configproduct['key_' + this.chooseProductId].status) {
          return this.i18n.joinNow;
        }
        return this.i18n.outOfStock;
      },

      /**
       * 购买方法
       * 当值为3时，即可“加入购物车”也可“立即购买”；
       * 当值为2时，只能“立即购买”；
       * 当值为其它或无此键时，只能“加入购物车”。
       */
      purchaseMethod: function purchaseMethod() {
        return Number(this.productInfo.purchase_method || 0);
      },
      isShowBuyNowBtn: function isShowBuyNowBtn() {
        return [2, 3].indexOf(this.purchaseMethod) > -1;
      },
      isShowAddToCartBtn: function isShowAddToCartBtn() {
        return this.purchaseMethod !== 2;
      },
      currentPickupList: function currentPickupList() {
        var pickUpData = this.productInfo.pickUp || {};
        if (!this.chooseProductId || !pickUpData || (typeof pickUpData === 'undefined' ? 'undefined' : _typeof(pickUpData)) !== 'object') {
          return [];
        }

        var currentPickupList = pickUpData['key_' + this.chooseProductId];
        return Array.isArray(currentPickupList) ? currentPickupList : [];
      },
      pickupMaxSaleQty: function pickupMaxSaleQty() {
        return this.currentPickupList.reduce(function (maxQty, warehouse) {
          var qty = Number.parseInt(warehouse && warehouse.qty, 10);
          return Number.isNaN(qty) ? maxQty : Math.max(maxQty, qty);
        }, 0);
      },
      isPickupConfirmDisabled: function isPickupConfirmDisabled() {
        if (this.action === 'pickUp') {
          return !this.isPickUp;
        }

        return this.cartToStock === this.i18n.outOfStock || !this.isPickUp;
      },
      maxSaleQty: function maxSaleQty() {
        if (this.action === 'pickUp' && this.isPickUp) {
          return this.pickupMaxSaleQty;
        }

        var maxSaleQty = this.productInfo.max_sale_qty;
        if (this.productInfo.product_type === 'configurable' && this.chooseProductId) {
          var chooseProduct = this.productInfo.configproduct['key_' + this.chooseProductId];
          maxSaleQty = chooseProduct && chooseProduct.max_sale_qty;
        }
        var qty = Number.parseInt(maxSaleQty);
        return Number.isNaN(qty) ? 0 : qty;
      },
      isDecreaseDisabled: function isDecreaseDisabled() {
        return this.qty <= 1;
      },
      isIncreaseDisabled: function isIncreaseDisabled() {
        return this.maxSaleQty > 0 && this.qty >= this.maxSaleQty;
      },
      modalImage: function modalImage() {
        if (this.productInfo.defaultImages && this.productInfo.defaultImages.length) {
          return this.productInfo.defaultImages[0];
        }
        return this.productInfo.image || this.productInfo.imgurl || '';
      },
      successDialogButtons: function successDialogButtons() {
        return [{
          text: this.i18n.checkout,
          action: 'checkout',
          type: 'primary'
        }];
      }
    },
    mounted: function mounted() {
      this.init();
      this.showEvent();
      this.hideEvent();
      this.hide();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
      if (this.onShowSpecModal) {
        busEvent.$off('selectSpecShowEvent', this.onShowSpecModal);
      }
      if (this.onHideSpecModal) {
        busEvent.$off('selectSpecHideEvent', this.onHideSpecModal);
      }
    },

    methods: {
      init: function init() {
        if (this.productInfo.product_type === 'simple') {
          this.chooseProductId = this.productInfo.product_id;
          this.reportProductView();
        }
      },

      /**
       * show modal event
       */
      showEvent: function showEvent() {
        var _this = this;

        this.onShowSpecModal = function (action) {
          _this.action = action;
          if (_this.showTimer) {
            clearTimeout(_this.showTimer);
          }
          _this.showTimer = setTimeout(function () {
            _this.show();
            _this.showTimer = null;
          }, 0);
        };
        busEvent.$on('selectSpecShowEvent', this.onShowSpecModal);
      },

      /**
       * hide modal event
       */
      hideEvent: function hideEvent() {
        var _this2 = this;

        this.onHideSpecModal = function () {
          _this2.hide();
        };
        busEvent.$on('selectSpecHideEvent', this.onHideSpecModal);
      },

      /**
       * show select spec modal
       */
      show: function show() {
        var _this3 = this;

        if (this.productInfo.product_type === 'configurable') {
          this.isUnpurchasable = false;
        }
        this.visible = true;
        this.$nextTick(function () {
          _this3.opened();
        });
      },

      /**
       * hide select spec modal
       */
      hide: function hide() {
        if (this.showTimer) {
          clearTimeout(this.showTimer);
          this.showTimer = null;
        }
        this.visible = false;
      },
      opened: function opened() {
        var _this4 = this;

        setTimeout(function (id) {
          _this4.initChooseAttr();
        }, 200);
      },

      /**
       * 默认都可以选择购买
       */
      emptyChooseAttr: function emptyChooseAttr() {
        var attr = this.productInfo.configattr;
        this.isUnpurchasable = false;
        for (var item in attr) {
          for (var option in attr[item].options) {
            Vue.set(attr[item].options[option], 'stockStates', true);
            Vue.set(attr[item].options[option], 'chooseStates', true);
          }
        }
      },

      /**
       * 对选择属性做是否有货标识处理
       * @param option
       * @param event
       * @returns {*}
       */
      chooseAttr: function chooseAttr(option, event) {
        this.emptyCandidateProduct(option.code);
        var target = event.target;
        this.emptyChooseAttr();
        // 处理当前选中样式
        $(target).parents('ul').find('a').removeClass('active');
        $(target).addClass('active');
        if (this.productInfo.configattr.length > 1) {
          // if判断为了处理只有一个选择属性时处理
          var isChooseIds = new Set(option.product_ids);
          var parentIndex = $(target).parents('.in-choose-attrs').siblings().attr('parent');
          var attrObj = this.productInfo.configattr[parentIndex].options;
          for (var item in attrObj) {
            var productIds = attrObj[item].product_ids;
            for (var id in productIds) {
              if (isChooseIds.has(productIds[id])) {
                if (this.productInfo.configproduct['key_' + productIds[id]].status) {
                  Vue.set(attrObj[item], 'stockStates', true);
                } else {
                  Vue.set(attrObj[item], 'stockStates', false);
                }
              }
            }
          }
          return this.candidateProduct(option);
        } else {
          var _parentIndex = $(target).parents('.in-choose-attrs').attr('parent');
          var _attrObj = this.productInfo.configattr[_parentIndex].options;
          for (var _item in _attrObj) {
            var _productIds = _attrObj[_item].product_ids;
            for (var _id in _productIds) {
              if (this.productInfo.configproduct['key_' + _productIds[_id]].status) {
                Vue.set(_attrObj[_item], 'stockStates', true);
              } else {
                Vue.set(_attrObj[_item], 'stockStates', false);
              }
            }
          }
          return this.chooseProductAttribute(option, _parentIndex);
        }
      },

      /**
       * 清空候选的productsid
       * @param code
       */
      emptyCandidateProduct: function emptyCandidateProduct(code) {
        if (this.$data['cacheAttr'][code]) {
          this.$data['cacheAttr'][code].clear();
        }
      },

      /**
       * 根据选中的属性，构建候选的productsid
       * @param option
       */
      candidateProduct: function candidateProduct(option) {
        var productIds = option.product_ids;
        if (!this.$data['cacheAttr'][option.code]) {
          this.$data['cacheAttr'][option.code] = new Set();
        }
        for (var id in productIds) {
          this.$data['cacheAttr'][option.code].add(productIds[id]);
        }
        return this.chooseProductAttribute(option);
      },

      /**
       * 设置选中的属性
       * @param option
       * @returns {*}
       */
      chooseProductAttribute: function chooseProductAttribute(option) {
        var parentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        this.chooseProductAttr.set(option.code, {
          'attribute_id': option.attribute_id,
          'option_id': option.option_id,
          'attribute_label': option.label
        });
        var str = '';
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.chooseProductAttr.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var attr = _step.value;

            str += str ? '--' + attr.attribute_label : attr.attribute_label;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.selectedItemDesc = str;
        this.updateSelectedDesc(this.selectedItemDesc);
        return this.isChooseProductId(option, parentIndex);
      },

      /**
       * 找出选中的config product id
       */
      isChooseProductId: function isChooseProductId(option) {
        var _this5 = this;

        var parentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        this.lastChooseProductId = this.chooseProductId; // 上一次选中产品id
        if (this.productInfo.configattr.length > 2) {
          // if判断为了处理只有一个选择属性时处理
          var _Object$keys = Object.keys(this.$data['cacheAttr']),
              _Object$keys2 = _slicedToArray(_Object$keys, 3),
              _Object$keys2$ = _Object$keys2[0],
              attrName1 = _Object$keys2$ === undefined ? '' : _Object$keys2$,
              _Object$keys2$2 = _Object$keys2[1],
              attrName2 = _Object$keys2$2 === undefined ? '' : _Object$keys2$2,
              _Object$keys2$3 = _Object$keys2[2],
              attrName3 = _Object$keys2$3 === undefined ? '' : _Object$keys2$3;

          var attr1 = this.$data['cacheAttr'][attrName1] || new Set();
          var attr2 = this.$data['cacheAttr'][attrName2] || new Set();
          var attr3 = this.$data['cacheAttr'][attrName3] || new Set();
          if (attr1.size > 0 || attr2.size > 0 || attr3.size > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = attr2.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                if (attr1.has(item)) {
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = attr3.values()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var id = _step3.value;

                      if (item === id) {
                        this.chooseProductId = item;
                        this.updateChooseProductId(item);
                      }
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } else if (this.productInfo.configattr.length === 2) {
          var _Object$keys3 = Object.keys(this.$data['cacheAttr']),
              _Object$keys4 = _slicedToArray(_Object$keys3, 2),
              _Object$keys4$ = _Object$keys4[0],
              _attrName = _Object$keys4$ === undefined ? '' : _Object$keys4$,
              _Object$keys4$2 = _Object$keys4[1],
              _attrName2 = _Object$keys4$2 === undefined ? '' : _Object$keys4$2;

          var _attr = this.$data['cacheAttr'][_attrName] || new Set();
          var _attr2 = this.$data['cacheAttr'][_attrName2] || new Set();
          if (_attr.size > 0 || _attr2.size > 0) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = _attr2.values()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _item2 = _step4.value;

                if (_attr.has(_item2)) {
                  this.chooseProductId = _item2;
                  this.updateChooseProductId(_item2);
                }
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        } else {
          this.productInfo.configattr[parentIndex].options.forEach(function (item) {
            if (item.option_id === _this5.chooseProductAttr.get(option.code).option_id) {
              _this5.chooseProductId = item.product_ids[0];
              _this5.updateChooseProductId(_this5.chooseProductId);
            }
          });
        }
        if (this.chooseProductId !== 0) {
          this.reportProductView(option, parentIndex);
        }
        return this.changePrice();
      },

      /**
       * 修改选中config product 后的价格
       * @returns {*}
       */
      changePrice: function changePrice() {
        if (this.chooseProductId !== 0) {
          var chooseProduct = this.productInfo.configproduct['key_' + this.chooseProductId];
          // 处理productInfo中的price
          this.productInfo.origin_price_label = chooseProduct.origin_price_label;
          this.productInfo.price_label = chooseProduct.price_label;
          this.productInfo.price = chooseProduct.price;
          this.productInfo.level_price = chooseProduct.level_price;
        }
        return this.switchImage(this.chooseProductId);
      },

      /**
       * 获取选中product图片资源
       */
      switchImage: function switchImage(id) {
        busEvent.$emit('getProductImgsEvent', id);

        this.$emit('getCityQtyById', id);
        busEvent.$emit('getRecommendProduct', id);
      },

      /**
       * add to cart
       */
      addToCart: function addToCart() {
        var _this6 = this;

        if (this.productBlock === 'pre_order' && !this.productInfo.pre_order_is_join && this.productInfo.can_direct_shopping !== '1') {
          this.fillMsg(this.i18n.presellAuthority);
          return this.showInfoModal();
        }
        var addCartBtn = $('.in-btn a');
        var purchaseStatus = addCartBtn.attr('class');
        if (purchaseStatus.indexOf('disabled') >= 0) {
          return false;
        }

        if (this.validate()) {
          this.hide();
          var tmpArr = [];
          if (this.productInfo.product_type === 'simple') {
            tmpArr['id'] = this.chooseProductId;
            tmpArr['qty'] = this.qty;
            this.selectedItemDesc = this.productInfo.name + ' ' + this.productInfo.short_description;
          } else {
            tmpArr['id'] = this.chooseProductId;
            tmpArr['qty'] = this.qty;
            tmpArr['super_attribute'] = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = this.chooseProductAttr.values()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var attr = _step5.value;

                tmpArr['super_attribute'][attr.attribute_id] = attr.option_id;
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }

          var pkgQty = this.qty;
          var chooseProductId = this.chooseProductId;
          if (this.chooseProductPackage.size > 0) {
            var product = this.productInfo.attachment.product;
            var optionId = this.productInfo.attachment.option[0].option_id;
            tmpArr['bundle'] = [];
            tmpArr['bundle']['product'] = product;
            tmpArr['bundle']['bundle_option_qty'] = [];
            tmpArr['bundle']['bundle_option'] = [];
            tmpArr['bundle']['bundle_option_qty'][optionId] = this.qty;
            this.productInfo.attachment.option[0].options.forEach(function (item, index, arr) {
              if (item.product_id === chooseProductId) {
                tmpArr['bundle']['bundle_option'][optionId] = item.selection_id;
              }
            });
            this.chooseProductPackage.forEach(function (key, value, map) {
              tmpArr['bundle']['bundle_option_qty'][value] = pkgQty;
              tmpArr['bundle']['bundle_option'][value] = key.selection_id;
            });
          }

          // add to cart http
          addToCartApi({
            data: window.serialize(tmpArr)
          }).then(function (resData) {
            _this6.facebookAddToCart();
            _this6.reportAddToCart('addToCart');
            _this6.updateQty();
            _this6.updateSelectedDesc(_this6.selectedItemDesc);
            if (_this6.useGlobalSuccessModal) {
              busEvent.$emit('modalSuccess', 'Added to cart successfully');
            } else {
              _this6.showAddToCartSuccessDialog("'" + _this6.productInfo.name + "' " + _this6.i18n.addedToCart);
            }
          });
        } else {
          this.isUnpurchasable = true;
          this.hide();
          return false;
        }
      },

      /**
       * validate choose product data
       * @returns {boolean}
       */
      validate: function validate() {
        // 验证是否选中足够的属性
        if (this.productInfo.product_type === 'configurable') {
          if (this.productInfo.configattr.length > 1) {
            // if判断为了处理只有一个选择属性时处理
            if (this.chooseProductAttr.size < 2) {
              // 预留未选择足够的属性处理
              this.fillMsg(this.i18n.selectAttr);
              this.hide();
              this.showInfoModal();
              return false;
            }
          } else {
            if (!this.chooseProductId) {
              this.fillMsg(this.i18n.selectAttr);
              this.hide();
              this.showInfoModal();
              return false;
            }
          }
        }
        // 验证库存是否足够，验证是否是out of stock
        if (this.productInfo.product_type === 'simple') {
          if (!(Number.parseInt(this.productInfo.max_sale_qty) >= this.qty && this.productInfo.status)) {
            // 预留simple库存不足处理
            this.fillMsg(this.productInfo.max_sale_qty + this.i18n.overQty);
            this.hide();
            this.showInfoModal();
            return false;
          }
        } else {
          if (!(Number.parseInt(this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty) >= this.qty && this.productInfo.configproduct['key_' + this.chooseProductId].status)) {
            // 预留config库存不足处理
            this.fillMsg(Number.parseInt(this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty) + this.i18n.overQty);
            this.hide();
            this.showInfoModal();
            return false;
          }
        }
        return true;
      },

      /**
       * 加入shopping cart后更新qty数量
       */
      updateQty: function updateQty() {
        if (this.productInfo.product_type === 'simple') {
          this.productInfo.max_sale_qty = Number.parseInt(this.productInfo.max_sale_qty) - this.qty;
        } else {
          this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty = Number.parseInt(this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty) - this.qty;
        }
      },

      /**
       * update slected desc
       */
      updateSelectedDesc: function updateSelectedDesc(text) {
        busEvent.$emit('updateSelectedDescEvent', text);
      },

      /**
       * 加入shopping cart后弹出框
      */
      fillMsg: function fillMsg(resData) {
        busEvent.$emit('fillModalMsgEvent', resData);
      },
      showAddToCartSuccessDialog: function showAddToCartSuccessDialog(message) {
        this.successDialogTitle = message;
        this.$modal.show('addToCartSuccessDialog');
      },
      handleSuccessDialogAction: function handleSuccessDialogAction(action) {
        this.$modal.hide('addToCartSuccessDialog');
        if (action === 'checkout') {
          this.redirectCheckout();
        }
      },
      showSuccessModal: function showSuccessModal() {
        busEvent.$emit('showSuccessModalEvent');
      },
      redirectCheckout: function redirectCheckout() {
        Util.redirect('/checkout/cart');
      },
      showInfoModal: function showInfoModal() {
        busEvent.$emit('showInfoModalEvent');
      },

      /**
       * 减少QTY
       */
      decrease: function decrease() {
        if (this.isDecreaseDisabled) {
          return false;
        }
        if (this.qty > 1) {
          this.qty--;
        }
      },

      /**
       * 增加QTY
       */
      increase: function increase() {
        if (this.isIncreaseDisabled) {
          return false;
        }
        if (this.productInfo.product_type === 'simple') {
          if (Number.parseInt(this.productInfo.max_sale_qty) <= this.qty) {
            this.fillMsg(Number.parseInt(this.productInfo.max_sale_qty) + this.i18n.overQty);
            this.showInfoModal();
            return false;
          } else {
            this.qty++;
          }
        } else {
          if (Number.parseInt(this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty) <= this.qty) {
            this.fillMsg(Number.parseInt(this.productInfo.configproduct['key_' + this.chooseProductId].max_sale_qty) + this.i18n.overQty);
            this.showInfoModal();
            return false;
          } else {
            this.qty++;
          }
        }
      },

      /**
       * 直接修改QTY
       * @param event
       */
      changeItemQty: function changeItemQty(event) {
        var target = event.target;
        var targetQty = target.value;
        var numReg = /^\d+$/ig;
        if (numReg.test(targetQty)) {
          targetQty = Number.parseInt(targetQty);
          if (targetQty > 0) {
            this.qty = targetQty;
          } else {
            target.value = this.qty;
          }
        } else {
          target.value = this.qty;
        }
      },
      updateChooseProductId: function updateChooseProductId(id) {
        busEvent.$emit('updateChooseProductIdEvent', id);
      },
      initChooseAttr: function initChooseAttr() {
        var _this7 = this;

        if (this.productInfo.product_type === 'configurable') {
          this.inStockClick();
          if (this.selectOptions.length > 0) {
            for (var idx in this.selectOptions) {
              this.clickAttrByOptionId(this.selectOptions[idx]);
            }
          } else {
            if ($('.in-choose-attrs ul').length === 1) {
              $('.in-attrs-container').first().find('ul li:first-child a').click();
            } else if ($('.in-choose-attrs ul').length === 2) {
              $('.in-choose-attrs ul').first().find('li:first-child').children()[0].click();
              $('.in-choose-attrs ul').last().find('li:first-child').children()[0].click();
            } else if ($('.in-choose-attrs ul').length === 3) {
              $('.in-choose-attrs ul').first().find('li:first-child').children()[0].click();
              $('.in-choose-attrs[parent=1] ul').find('li:first-child').children()[0].click();
              $('.in-choose-attrs ul').last().find('li:first-child').children()[0].click();
            }
          }

          setTimeout(function () {
            _this7.switchImage(_this7.chooseProductId);
          }, 20);
        }
        this.chooseProductPackage = new Map();
      },
      inStockClick: function inStockClick() {
        var _this8 = this;

        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var productIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var _loop = function _loop(idx) {
          var ids = _this8.productInfo.configattr[index].options[idx].product_ids;
          if (index != 0) {
            ids = productIds.filter(function (v) {
              return ids.includes(v);
            });
          }
          if (_this8.productInfo.configattr.length - 1 == index) {
            if (productIds.length > 0) {
              if (_this8.chooseProductId == ids[0] || _this8.chooseProductId == 0 && _this8.productInfo.configproduct['key_' + ids[0]] !== undefined && _this8.productInfo.configproduct['key_' + ids[0]].qty > 0) {
                //this.clickAttrByOptionId(this.productInfo.configattr[index].options[idx]);
                _this8.selectOptions[index] = _this8.productInfo.configattr[index].options[idx];
                return {
                  v: true
                };
              }
            }
          } else {
            if (_this8.inStockClick(index + 1, ids)) {
              //this.clickAttrByOptionId(this.productInfo.configattr[index].options[idx]);
              _this8.selectOptions[index] = _this8.productInfo.configattr[index].options[idx];
              return {
                v: true
              };
            }
          }
        };

        for (var idx in this.productInfo.configattr[index].options) {
          var _ret = _loop(idx);

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
        return false;
      },
      clickAttrByOptionId: function clickAttrByOptionId(option) {
        this.emptyCandidateProduct(option.code);
        this.emptyChooseAttr();
        this.candidateProduct(option);
        $('.in-choose-attrs').find('ul li[optionId=' + option.option_id + '] a').removeClass('inactive').addClass('active').siblings().removeClass('active').addClass('inactive');
      },
      facebookAddToCart: function facebookAddToCart() {
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_type: 'product',
            content_ids: this.chooseProductId,
            value: this.subTotal(),
            currency: window.commonDataJSON.current_currency_code
          });
        }
      },
      subTotal: function subTotal() {
        return parseFloat(this.productInfo.price) * this.qty;
      },
      joinPreOrder: function joinPreOrder() {
        var _this9 = this;

        if (!this.isLogin) {
          return Util.redirect(this.loginUrl);
        }
        if (!this.productInfo.pre_order_is_join) {
          this.hide();
          addPreOrderApi({
            product_id: this.productInfo.product_id
          }).then(function (resData) {
            _this9.fillMsg(resData.msg);
            _this9.showInfoModal();
          });
        } else {
          return false;
        }
      },

      /**
       * 选择套餐配件
       * @param event
       */
      choosePackage: function choosePackage(event, option, item) {
        var target = $(event.target);
        if (target.hasClass('in-package-item')) {
          if (target.hasClass('active')) {
            target.removeClass('active').siblings().removeClass('inactive');
            this.chooseProductPackage.delete(item.option_id);
          } else {
            target.removeClass('inactive').addClass('active').siblings().removeClass('active').addClass('inactive');
            this.chooseProductPackage.set(item.option_id, {});
            this.chooseProductPackage.set(item.option_id, {
              'selection_id': option.selection_id
            });
          }
        } else {
          if (target.parents('section').hasClass('active')) {
            target.parents('section').removeClass('active').siblings().removeClass('inactive');
            this.chooseProductPackage.delete(item.option_id);
          } else {
            target.parents('section').removeClass('inactive').addClass('active').siblings().removeClass('active').addClass('inactive');
            this.chooseProductPackage.set(item.option_id, {});
            this.chooseProductPackage.set(item.option_id, {
              'selection_id': option.selection_id
            });
          }
        }
      },
      buyNow: function buyNow() {
        if (this.validate()) {
          this.hide();
          var tmpArr = [];
          if (this.productInfo.product_type === 'simple') {
            tmpArr['id'] = this.chooseProductId;
            tmpArr['qty'] = this.qty;
            this.selectedItemDesc = this.productInfo.name + ' ' + this.productInfo.short_description;
          } else {
            tmpArr['id'] = this.chooseProductId;
            tmpArr['qty'] = this.qty;
            tmpArr['super_attribute'] = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = this.chooseProductAttr.values()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var attr = _step6.value;

                tmpArr['super_attribute'][attr.attribute_id] = attr.option_id;
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }

          var pkgQty = this.qty;
          var chooseProductId = this.chooseProductId;
          if (this.chooseProductPackage.size > 0) {
            var product = this.productInfo.attachment.product;
            var optionId = this.productInfo.attachment.option[0].option_id;
            tmpArr['bundle'] = [];
            tmpArr['bundle']['product'] = product;
            tmpArr['bundle']['bundle_option_qty'] = [];
            tmpArr['bundle']['bundle_option'] = [];
            tmpArr['bundle']['bundle_option_qty'][optionId] = this.qty;
            this.productInfo.attachment.option[0].options.forEach(function (item, index, arr) {
              if (item.product_id === chooseProductId) {
                tmpArr['bundle']['bundle_option'][optionId] = item.selection_id;
              }
            });
            this.chooseProductPackage.forEach(function (key, value, map) {
              tmpArr['bundle']['bundle_option_qty'][value] = pkgQty;
              tmpArr['bundle']['bundle_option'][value] = key.selection_id;
            });
          }

          buyNowApi({
            data: window.serialize(tmpArr)
          }).then(function (resData) {
            Util.redirect('/buynow');
          });
          this.reportAddToCart("buyNow");
        } else {
          this.isUnpurchasable = true;
          this.hide();
          return false;
        }
      },
      closePanel: function closePanel() {
        if (this.action === 'pickUp' && this.isPickupConfirmDisabled) {
          return false;
        }

        this.hide();
        var toCartData = this.getAddToCartData();
        if (toCartData && Object.keys(toCartData).length) {
          busEvent.$emit('sendToCartData', toCartData);
        }

        if (this.action === 'pickUp') {
          busEvent.$emit('pickUpEvent');
          return;
        }

        if (this.isOnlyPickUp) return;
      },
      getAddToCartData: function getAddToCartData() {
        var addCartBtn = $('.in-btn a');
        var purchaseStatus = addCartBtn.attr('class');
        if (purchaseStatus.indexOf('disabled') >= 0) {
          return [];
        }

        var tmpArr = [];
        if (this.productInfo.product_type === 'simple') {
          tmpArr['id'] = this.chooseProductId;
          tmpArr['qty'] = this.qty;
          this.selectedItemDesc = this.productInfo.name + ' ' + this.productInfo.short_description;
        } else {
          tmpArr['id'] = this.chooseProductId;
          tmpArr['qty'] = this.qty;
          tmpArr['super_attribute'] = [];
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = this.chooseProductAttr.values()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var attr = _step7.value;

              tmpArr['super_attribute'][attr.attribute_id] = attr.option_id;
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          var pkgQty = this.qty;
          var chooseProductId = this.chooseProductId;
          if (this.chooseProductPackage.size > 0) {
            var product = this.productInfo.attachment.product;
            var optionId = this.productInfo.attachment.option[0].option_id;
            tmpArr['bundle'] = [];
            tmpArr['bundle']['product'] = product;
            tmpArr['bundle']['bundle_option_qty'] = [];
            tmpArr['bundle']['bundle_option'] = [];
            tmpArr['bundle']['bundle_option_qty'][optionId] = this.qty;
            this.productInfo.attachment.option[0].options.forEach(function (item, index, arr) {
              if (item.product_id === chooseProductId) {
                tmpArr['bundle']['bundle_option'][optionId] = item.selection_id;
              }
            });
            this.chooseProductPackage.forEach(function (key, value, map) {
              tmpArr['bundle']['bundle_option_qty'][value] = pkgQty;
              tmpArr['bundle']['bundle_option'][value] = key.selection_id;
            });
          }
        }

        return tmpArr;
      },


      // 获取上报信息的产品数据
      getReportProductInfo: function getReportProductInfo(type, index) {
        var product = null;

        // if(this.productInfo.product_type === 'configurable'){
        //   product = this.productInfo.configproduct[`key_${this.chooseProductId}`];
        // }else{
        product = this.productInfo;
        // }

        var json = new GAReport().productItem(Object.assign(window.productDataJSON.data, product), index, 1, { variant: this.productVariant });

        if (type == "hasQty") {
          json.quantity = this.productInfo.qty;
        }

        return [json];
      },

      // 上报产品详情加载信息
      reportProductView: function reportProductView(option, parentIndex) {
        if (this.productInfo.product_type === 'configurable') {
          var chooseProduct = this.productInfo.configproduct['key_' + this.chooseProductId];
          if (!chooseProduct.name || !chooseProduct.sku) {
            return;
          }
        }

        var name = window.productDataJSON.data.name;
        var product_class = window.productDataJSON.data.product_class || "";
        var productList = this.getReportProductInfo(option, parentIndex);

        new GAReport().productView({
          eventAction: 'PRODUCT_VIEW_' + product_class + '_' + name,
          eventCategory: 'PRODUCT_VIEW_#VERSION#',
          productList: productList,
          configName: name
        });
      },

      // 上报添加到购物车
      reportAddToCart: function reportAddToCart(type) {
        var typeAction = {
          "addToCart": "PRODUCT_ADDTOCART_",
          "buyNow": "PRODUCT_BUYNOW_",
          "pickUp": "PRODUCT_PICKUP_"
        };

        if (typeAction[type]) {
          var name = window.productDataJSON.data.name;
          var product_class = window.productDataJSON.data.product_class || "";
          var productList = this.getReportProductInfo("hasQty", 1);

          new GAReport().productAddToCart({
            eventAction: typeAction[type] + product_class + '_' + name,
            eventCategory: typeAction[type] + '#VERSION#',
            productList: productList,
            configName: name
          });
        }
      }
    }
  };
});
